import ViewSubtitle from './ViewSubtitle'

export default ViewSubtitle
